export class ScheduleModel {
    constructor(
        public id:any,
        public minute: string,
        public hour: string,
        public day: string,
        public month: string,
        public week: string
    ) { }
}
